import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import MainQrCode from "../views/manage-qr-code/Main";
import MainSetting from '../views/manage-setting/Main'

export default function RootRouter () {
  return (
    <Switch>
      <Redirect exact from="/" to='/qr-code' />
      <Route path="/qr-code" component={MainQrCode} />
      <Route path="/setting" component={MainSetting} />
    </Switch>
  )
}